import $ from 'jquery'

/**
 * FixedHeaderの表示切り替え
 */
let startPos = 0, winScrollTop = 0
$(window).on('scroll', function() {
  //ブラウザの縦サイズを取得
  const wh_d = $(window).height()
  winScrollTop = $(this).scrollTop()

  if (winScrollTop <= wh_d) { //画面上部
    $('.js-fixed-header').css({
      'transform': 'translateY(-100%)',
    })
  } else if (winScrollTop >= startPos) { //下スクロール
    $('.js-fixed-header').css({
      'transform': 'translateY(-100%)',
    })
  } else {
    $('.js-fixed-header').css({
      'transform': 'translateY(0)',
    })
  }
  //現在のスクロール位置を保存
  startPos = winScrollTop
})
/**
 * スムーススクロール
 */

// スクロールの速度（ミリ秒）
const scrollSpeed = 400

$('a[href^="#"]').click(function() {
  const href = $(this).attr('href')
  const target = $(href === '#' || href === '' ? 'html' : href)
  // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
  const position = target.offset().top
  // スムーススクロール linear（等速） or swing（変速）
  $('body,html').animate({ scrollTop: position - 1 }, scrollSpeed, 'swing')
    // fixedヘッダーが必ず隠れるように最後に下スクロールで終わる
    .animate({ scrollTop: position + 1 }, 1, 'linear')
  return false
})


/**
 * /cpcのモバイルメニューのリンクを押下したとき
 * モーダルを閉じて、指定のセクションにスクロールする
 */
$('.mobile-menu__nav-item[href^="/cpc#"],.site-nav__plain-link-item[href^="/cpc#"]').click(function() {
  // モバイルメニューを閉じる
  $('#mobile-menu').modal('hide')
  // アンカーの値取得 リンク先（href）を取得して、idという変数に代入
  const id = String($(this).attr('href')).replace('/cpc#', '')
  // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
  const target = $('#' + id)
  // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
  const position = target.offset().top
  // スムーススクロール linear（等速） or swing（変速）
  $('body,html').animate({ scrollTop: position - 1 }, scrollSpeed, 'swing')
    // fixedヘッダーが必ず隠れるように最後に下スクロールで終わる
    .animate({ scrollTop: position + 1 }, 1, 'linear')

  return false
})

/**
 * SP版の追従CTAの表示切り替え
 */
const fixedCta = $('#js-fixed-cta')
const fixedCtaExists = fixedCta[0] !== undefined

if (fixedCtaExists) {
  $(window).on('scroll', function() {

    const fixedCtaPosition = fixedCta.offset().top
    const ctaSectionPosition = $('#js-section-cta').offset().top

    if (fixedCtaPosition < ctaSectionPosition) {
      fixedCta.css({
        'transform': 'translateY(0)',
      })
    } else {
      fixedCta.css({
        'transform': 'translateY(100%)',
      })
    }
  })
}

//予約日時の初期値を設定する
$(function(){
  const date = new Date()
  date.setDate(date.getDate() + 4)
  var year = date.getFullYear()
  //monthは0始まりのため+1
  var month = date.getMonth() + 1
  var day = date.getDate()
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  const initialDate = String(year) + '-' + String(month) + '-' + String(day)
  const reserveInput = $('input[name="reserve-date"]')
  reserveInput.val(initialDate)
  reserveInput.attr({"min": initialDate})
});
